import React, {useMemo, MouseEvent} from 'react';
import {Icon, Tooltip} from '@/ui-kits';
import {useSelector} from 'react-redux';
import {chatMessagesSelector, authDataSelector} from '@/services/redux/selectors';
import {ChatMessageStatus} from '@/constants';
import {cn} from '@/utils/common_functions';

type ButtonSize = 'sm' | 'md' | 'lg';
interface ChatButtonProps {
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
  chatId: number;
  size?: ButtonSize;
  className?: string;
}

const buttonVariant: Record<ButtonSize, {
  button: string,
  icon: string,
}> = {
  sm: {button: 'size-6', icon: 'size-3'},
  md: {button: 'size-10', icon: 'size-5'},
  lg: {button: 'size-14', icon: 'size-8'},
};

export const ChatButton: React.FC<ChatButtonProps> = props => {
  const {onClick, chatId, size = 'md', className} = props;
  // ==========================
  // hooks
  // ==========================

  // ==========================
  // selectors
  // ==========================
  const messages = useSelector(chatMessagesSelector(chatId));
  const authData = useSelector(authDataSelector);

  // ==========================
  // states
  // ==========================
  const unreadMessages = useMemo(() => {
    const unreadMessages = messages.filter(message => message.status === ChatMessageStatus.Sent && message.sender_id !== authData?.id);
    return unreadMessages.length;
  }, [messages, authData]);

  return (
    <Tooltip message="View Chat">
      <button
        onClick={onClick}
        className={cn(
          'flex relative z-0 aspect-square flex-shrink-0 bg-gradient-to-br from-ui_blue to-ui_blue_light rounded-full items-center justify-center',
          buttonVariant[size].button,
          className,
        )}>
        <Icon
          type="message"
          className={cn("h-auto", buttonVariant[size].icon,)}
        />
        {unreadMessages > 0 && (
          <span className="absolute -top-[6px] -right-[6px] bg-new text-black text-sm rounded-full size-5 flex items-center justify-center">
            {unreadMessages}
          </span>
        )}
      </button>
    </Tooltip>
  );
};
